<div [formGroup]="form">
  <div class="row g-3 mt-0">
    <div class="col-12 col-md-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>CEP</mat-label>
        <input matInput formControlName="entregaCep" placeholder="00000-000"
          [mask]="masks.cep" (blur)="buscarCep()">
        <!-- Mesmo sufixo do CEP no cadastro de Pessoa: lupa que busca, spinner enquanto busca. -->
        @if (isBuscandoCep) {
          <mat-spinner matSuffix diameter="18"></mat-spinner>
        } @else if (!isSomenteLeitura) {
          <mat-icon matSuffix class="vee-icone-busca" (click)="buscarCep()">search</mat-icon>
        }
        <mat-hint>Preenche o endereço automaticamente</mat-hint>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-7">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Logradouro</mat-label>
        <input matInput formControlName="entregaLogradouro">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Número</mat-label>
        <input matInput formControlName="entregaNumero">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Bairro</mat-label>
        <input matInput formControlName="entregaBairro">
      </mat-form-field>
    </div>

    <!-- UF antes de Município, e Município do cadastro filtrado pela UF (padrão da casa). O
         contrato guarda `entregaCidade` como texto: o nome do município escolhido vai para lá. -->
    <div class="col-12 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>UF</mat-label>
        <mat-select formControlName="entregaUf" (selectionChange)="aoTrocarUf()">
          @for (uf of ufs; track uf.id) {
            <mat-option [value]="uf.id">{{ uf.descricaoExibicao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <app-select-pesquisavel [control]="municipioControl" [apiUrl]="urlMunicipio" label="Município"
        idField="idMunicipio" nameField="nome" [preloadedOptions]="municipiosPreCarregados"
        (selectionChange)="aoEscolherMunicipio($event)">
      </app-select-pesquisavel>
    </div>

    <div class="col-12 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Complemento</mat-label>
        <input matInput formControlName="entregaComplemento">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-5">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Destinatário</mat-label>
        <input matInput formControlName="entregaDestinatario"
          placeholder="Quem recebe, se diferente do cliente">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Tipo</mat-label>
        <mat-select formControlName="entregaIdTipoPessoa">
          <mat-option [value]="tipoPessoaEnum.Fisica">Pessoa física</mat-option>
          <mat-option [value]="tipoPessoaEnum.Juridica">Pessoa jurídica</mat-option>
          <mat-option [value]="tipoPessoaEnum.Estrangeiro">Estrangeiro</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 col-md-5">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>CPF / CNPJ</mat-label>
        <!-- Formatador da casa (MaskService.onDocumentoInput), não a máscara do ngx-mask: ela prendia em CPF
             e não deixava passar para CNPJ, e perdia a formatação ao reabrir o painel. -->
        <input matInput formControlName="entregaCpfCnpj" maxlength="18" (input)="onDocumentoInput($event)">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-5">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Inscrição estadual</mat-label>
        <input matInput formControlName="entregaInscricaoEstadual">
      </mat-form-field>
    </div>

    <div class="col-12 col-md-4">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Telefone</mat-label>
        <input matInput formControlName="entregaTelefone" [mask]="masks.phone">
      </mat-form-field>
    </div>
  </div>
</div>
